import { Form, Formik } from "formik";
import React, { FC, useEffect, useState } from "react";
import { Button, InputWithSelect } from "../../../../../../components";
import { useAppDispatch, useAppSelector } from "../../../../../../store";
import { setGreyListOfStreets } from "../../../../../../store/slices/admin";
import appConfig from "../../../../../../util/appConfig";
import transformHexToRgba from "../../../../../../util/transformHexToRgba";
import Row from "./components/Row";
import style from "./style.module.scss";

interface IBlockLisForm {
  closeModalHandler: () => void;
}

interface IInitValues {
  strasseBezeichnung: string;
  homeNumbers: { from: string; to: string; id: string }[];
}

const BlockLisForm: FC<IBlockLisForm> = ({ closeModalHandler }) => {
  const dispatch = useAppDispatch();

  const { activeGreyListOfStreets, ignoredGreyListOfStreets } = useAppSelector((state) => state.admin);
  const [homeNumbers, setHomeNumbers] = useState<
    { from: string; to: string; id: string }[]
  >([]);

  const [selectedStreet, setSelectedStreet] = useState("");
  const initialValues: IInitValues = {
    strasseBezeichnung: selectedStreet,
    homeNumbers: [...homeNumbers],
  };
  const addRow = () => {
    const arr = [
      ...homeNumbers,
      { from: "", to: "", id: Math.floor(Math.random() * 10000000).toString() },
    ];
    setHomeNumbers(arr);
  };

  const deleteRowHandler = (id: string) => {
    const arr = homeNumbers.filter((i) => i.id !== id);

    setHomeNumbers(arr);
  };

  const changeHandler = (val: string, field: string, idx: number) => {
    const temp = homeNumbers.map((el, id) => {
      if (id === idx) {
        let qwe = { ...el };
        (qwe as any)[field] = val;
        return qwe;
      }
      return el;
    });
    setHomeNumbers([...temp]);
  };

  useEffect(() => {
    const item = ignoredGreyListOfStreets.find(
      (el) => el.strasseBezeichnung === selectedStreet
    );
    if (item) {
      setHomeNumbers(
        item.greyListHomeNumbers.map((el) => {
          return { from: el.from, to: el.to, id: el._id };
        })
      );
    }
  }, [selectedStreet]);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { resetForm }) => {
        const id = activeGreyListOfStreets
          .find((i) => i.strasseBezeichnung === values.strasseBezeichnung)
          ?.strasseNummer.toString()!;
        dispatch(
          setGreyListOfStreets({
            id,
            ignore: values.homeNumbers.length ? "partially" : "ignore",
            homeNumbers: [
              ...values.homeNumbers.map((i) => {
                return { from: i.from, to: i.to };
              }),
            ],
          })
        );
        // dispatch(updateStreets({ id: [id], ignore: values.blockedHouseNumbers.length ? 'partially' : 'ignore' }));
        resetForm();
        closeModalHandler();
      }}
      enableReinitialize
    >
      {(props) => {
        return (
          <Form>
            <InputWithSelect
              type="string"
              name="strasseBezeichnung"
              options={activeGreyListOfStreets.map((i) => {
                return {
                  value: i.strasseBezeichnung,
                  label: i.strasseBezeichnung,
                };
              })}
              hasFullWidth
              arrowTopLocation={"50%"}
              changeHandler={(v) => setSelectedStreet(v)}
            />
            {homeNumbers.length ? (
              <div>
                {homeNumbers.map((i, idx) => {
                  return (
                    <Row
                      deleteHandler={() => {
                        deleteRowHandler(i.id.toString());
                        props.values.homeNumbers.splice(idx, 1);
                        props.setFieldValue(
                          "homeNumbers",
                          props.values.homeNumbers
                        );
                      }}
                      key={i.id}
                      idx={idx}
                      onChange={(val: string, field: string) => {
                        changeHandler(val, field, idx);
                      }}
                    />
                  );
                })}
              </div>
            ) : null}
            {props.values.strasseBezeichnung ? (
              <div className={style.addHouseNumber} onClick={addRow}>
                + Add house numbers to grey list
              </div>
            ) : null}
            <div className={style.btnWrapper}>
              <Button
                text="Schließen"
                width="298"
                onClick={closeModalHandler}
                isOutlined={true}
                outlineColor={appConfig.mainColor}
                textColor={appConfig.mainColor}
              />
              <Button
                width="298"
                text="Speichern"
                backgroundColor={
                  props.values.strasseBezeichnung.length
                    ? appConfig.mainColor
                    : transformHexToRgba(appConfig.mainColor!, "0.4")
                }
                type="submit"
                disabled={!props.values.strasseBezeichnung.length}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default BlockLisForm;
